import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import { Doc } from '../types/backend-dto-types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetDocV2 = (
  matterId: string | undefined,
  docId: string | null,
  subsetId?: string,
  includeSurroundingDocIds = false,
) => {
  const { fetchConfigGET } = useGetFetchConfig();

  const queryParams = new URLSearchParams();
  if (subsetId) {
    queryParams.set('subsetId', subsetId);
  }
  if (includeSurroundingDocIds) {
    queryParams.set('includeSurroundingDocIds', 'true');
  }
  const queryString = queryParams.toString();

  return useQuery<Doc>(
    [QueryEntity.Doc, { docId, subsetId, includeSurroundingDocIds }],
    () => {
      const url = `${APIBaseChronos}/api/matters/${matterId}/docs/${docId}${queryString ? `?${queryString}` : ''}`;
      return fetch(url, fetchConfigGET).then((res) => {
        return res.json();
      });
    },
    {
      enabled: !!matterId && !!docId,
      refetchOnWindowFocus: false,
    },
  );
};
